<div class="notifications-container">
  <h1>{{ 'NOTIFICATIONS.TITLE' | translate }}</h1>

  <div class="notification-list" *ngIf="notifications$ | async as notifications; else loading">
    <ng-container *ngIf="notifications.length > 0; else noNotifications">
      <div *ngFor="let notification of notifications"
           class="notification-item"
           [class.unread]="!notification.isRead"
           [routerLink]="notification.link"
           (click)="onNotificationClicked(notification)">

        <div class="notification-icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div class="notification-content">
          <p class="message">{{ notification.message }}</p>
          <span class="timestamp">{{ notification.timestamp | date:'medium' }}</span>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #loading>
    <p>{{ 'NOTIFICATIONS.LOADING' | translate }}</p>
  </ng-template>

  <ng-template #noNotifications>
    <p>{{ 'NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}</p>
  </ng-template>
</div>
